export class ResourceStatistics {
    templateCount: number = 0;
    jsonFileCount: number = 0;
    jsonKeyCount: number = 0;
    jsonArrayCount: number = 0;
    dynamicDataHandlerCount: number = 0;
    dynamicViewHandlerCount: number = 0;

    constructor() {}
}
